import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "position-relative" };
const _hoisted_2 = {
    class: "form-check-label",
    for: "policy-check"
};
const _hoisted_3 = ["href"];
import ValidateState from '@vue/components/form/ValidateState.vue';
import { $lang } from '@vue/services/utilities';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PolicyCheckField',
    setup(__props) {
        const field = useField('policy-check', 'required');
        const validateInputClass = ref();
        const validateTooltipClass = ref();
        const privacyUrl = inject('privacyUrl', '');
        function changeValidateState(v) {
            validateInputClass.value = v.inputClass;
            validateTooltipClass.value = v.tooltipClass;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(field).value.value) = $event)),
                    name: "policy-check",
                    class: _normalizeClass(["form-check-input", validateInputClass.value]),
                    type: "checkbox",
                    id: "policy-check"
                }, null, 2), [
                    [_vModelCheckbox, _unref(field).value.value]
                ]),
                _createElementVNode("label", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_unref($lang)('app.reservation.form.checkbox.policy.agree')) + " ", 1),
                    _createElementVNode("a", {
                        href: _unref(privacyUrl),
                        target: "_blank"
                    }, _toDisplayString(_unref($lang)('app.reservation.form.checkbox.policy')), 9, _hoisted_3)
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(validateTooltipClass.value)
                }, _toDisplayString(_unref(field).errorMessage), 3),
                _createVNode(ValidateState, {
                    field: _unref(field),
                    onValidateState: changeValidateState
                }, null, 8, ["field"])
            ]));
        };
    }
});
